import React__default from 'react';
import cn from 'classnames';

const TreeviewItem = /*#__PURE__*/React__default.forwardRef(function TreeviewItem(props, ref) {
  return React__default.createElement("a", Object.assign({}, props, {
    ref: ref
  }));
});
const TreeviewGroup = /*#__PURE__*/React__default.forwardRef(function TreeviewGroup(props, ref) {
  const {
    children,
    className: externalClassName,
    expanded: initialExpanded = false,
    title,
    fixed,
    onClick,
    ...otherProps
  } = props;
  const [expanded, setExpanded] = React__default.useState(fixed || initialExpanded);
  React__default.useEffect(() => {
    if (!fixed) {
      setExpanded(fixed || initialExpanded);
    }
  }, [fixed, initialExpanded]);
  const listClassName = cn('flex-col mb-0', {
    flex: expanded,
    hidden: !expanded
  });
  const itemProps = { ...otherProps,
    'aria-expanded': expanded,
    role: 'treeitem',
    tabIndex: -1
  };

  const handleClick = event => {
    const nextState = !expanded;

    if (!fixed) {
      setExpanded(nextState);
    }

    if (onClick) {
      onClick(event, nextState);
    }
  };

  const className = typeof externalClassName === 'function' ? externalClassName(expanded) : externalClassName;
  return React__default.createElement("div", Object.assign({}, itemProps, {
    className: className,
    ref: ref
  }), React__default.createElement("div", {
    onClick: handleClick
  }, typeof title === 'function' ? title(expanded) : title), React__default.createElement("ul", {
    role: "group",
    className: listClassName
  }, React__default.Children.toArray(children).filter(item => !!item).map((item, i) => React__default.createElement("li", {
    key: i,
    role: "none"
  }, React__default.cloneElement(item, {
    role: 'treeitem'
  })))));
});
const Treeview = /*#__PURE__*/React__default.forwardRef(function Treeview(props, ref) {
  return React__default.createElement("div", Object.assign({}, props, {
    ref: ref,
    role: "tree"
  }));
});
Treeview.Group = TreeviewGroup;
Treeview.Item = TreeviewItem;

export { Treeview };
//# sourceMappingURL=Treeview.js.map
